
var teyutoVideoPlayer;

var videojsIsPaused = false;

// ---------------------------------------------------------------------------
// Analytics di riproduzione (action_enter / action_update): RIPRISTINATE
// dopo la migrazione a Video.js 10. Usano solo la superficie v8-style
// dell'adapter TyPlayer (on / currentTime()), quindi funzionano invariate.
// ---------------------------------------------------------------------------
var firstTimeEnter = true;
var semNextAutoplay = false;
var ct = 0;
var secondPlayed = 0;
var updateTimeAnalytics;

function incrementSeconds(player, idl, action) {
	if (videojsIsPaused == false) {
		secondPlayed += 0.5;
		if (secondPlayed >= 20) {
			updateTimeVideo(idl, player.currentTime(), action, 0, secondPlayed);
			secondPlayed = 0;
		}
	}
}

var sem_timeenter = 0;
var current_id_action_update = 0;

function timeEnter(player, idl, time) {

	var dataEnterFirst = "";
	if (firstTimeEnter) {
		dataEnterFirst = "&firstTime=1";
		firstTimeEnter = false;
	}

	var dataString = "id=" + idl + "&time=" + time + dataEnterFirst;

	$.ajax({
		type: "POST",
		url: URL_API + '/video/?f=action_enter',
		data: dataString,
		cache: false,
		success: function (c) {
			var objJson = JSON.parse(c);
			action = objJson[0].action;

			//sovrascrivo quella globale
			current_id_action_update = action;

			if (sem_timeenter == 0) {
				updateTimeAnalytics = setInterval(function () {
					incrementSeconds(player, idl, current_id_action_update);
				}, 500);

				player.on("pause", function (e) {
					try { e.stopPropagation(); } catch (err) {}
					pauseTime = player.currentTime();
					updateTimeVideo(idl, pauseTime, current_id_action_update, 1, secondPlayed);
					secondPlayed = 0;

					$('.hideWhenStartPlay').show();
				});

				sem_timeenter = 1;
			}
			//CHIUDI E CAMBI PAGINA
			window.onbeforeunload = function (e) {
				clearInterval(updateTimeAnalytics);
				updateTimeVideo(idl, player.currentTime(), action, 1, secondPlayed);
			};
			return objJson[0].action;
		}
	});
}

function updateTimeVideo(id, time, action, end, sp) {
	$.post(URL_API + "/video/?f=action_update", {
		id: id,
		time: time,
		action: action,
		end: end,
		sp: sp
	}, function (c) {
	})
}

function initPlayerStat(player, idl) {

    try {
        clearInterval(updateTimeAnalytics);
    } catch (error) {}

	var playTime = 0;

	startTime = player.currentTime();
	player.on("play", function (e) {

		semNextAutoplay = false;

		timeleft = 15;

		playTime = player.currentTime();

		timeEnter(player, idl, playTime);

	});

}

// TODO(v10): popups in-player (initPlayerPopup, era videojs-overlay) rimossi
// col passaggio a Video.js 10 — da ricostruire su v10.

function countdownVideoLive(dateStart) {
    var currentDate = new Date();
    var startDate = new Date(dateStart);
    var timeDiff = startDate.getTime() - currentDate.getTime();
    var secondsRemaining = Math.floor(timeDiff / 1000);
    var messageContainer = '';
    if (secondsRemaining <= 0) {
        messageContainer = `
        ${translate('GO_LIVE')} offline
        `;
    } else {
        // Calcola il countdown
        var days = Math.floor(secondsRemaining / (3600 * 24));
        var hours = Math.floor((secondsRemaining % (3600 * 24)) / 3600);
        var minutes = Math.floor((secondsRemaining % 3600) / 60);
        var seconds = secondsRemaining % 60;

        // Formatta il countdown come stringa
        var countdownString = padZero(days) + ":" + padZero(hours) + ":" + padZero(minutes) + ":" + padZero(seconds);

        // Visualizza il countdown
        messageContainer = `
        <div class="text-center">
            ${translate('LIVE_START_IN')}<br><br>
            <span style="color:black; font-size: 30px; margin-top:10px;" class="xbold countdown_timer_video">${countdownString}</span>
        </div>
        `;
    }

    $('#video-section-unique').append(`<div id="countdown-live-stream">${messageContainer}</div>`);


    // Avvia il countdown
    var countdownInterval = setInterval(function () {
        secondsRemaining--;
        if (secondsRemaining <= 0) {
            clearInterval(countdownInterval);
            return;
        }
        days = Math.floor(secondsRemaining / (3600 * 24));
        hours = Math.floor((secondsRemaining % (3600 * 24)) / 3600);
        minutes = Math.floor((secondsRemaining % 3600) / 60);
        seconds = secondsRemaining % 60;
        countdownString = padZero(days) + ":" + padZero(hours) + ":" + padZero(minutes) + ":" + padZero(seconds);
        $('.countdown_timer_video').text(countdownString);
    }, 1000);
}

function closeVideoCountdown(){
    $('#countdown_video').remove();
}
// Funzione di utilità per aggiungere uno zero davanti a numeri inferiori a 10
function padZero(num) {
    return (num < 10 ? '0' : '') + num;
}


function goToNextVideo(video) {
    loadPageVideo(video);
}

// Autoplay del prossimo video: a fine riproduzione mostra la card up-next
// del core (countdown circolare, titolo/thumbnail, "Riproduci ora"/
// "Annulla"); a countdown terminato — o su conferma — parte il prossimo.
function autoplayNextVideo(player, videoId) {
    $.ajax({
        type: "GET",
        url: URL_API2 + "/contents/videos/" + videoId + "/next",
        cache: false,
        success: function (json) {
            let obj = JSON.parse(json);
            if (obj.status == 200) {
                obj = obj.contents;
                player.on('ended', function () {
                    if (!goToNextVideoSem) {
                        return;
                    }
                    TyPlayer.showUpNext(player, {
                        title: obj[0].title,
                        image: obj[0].image,
                        seconds: 10,
                        headText: translate('GOT_NEXT_VIDEO'),
                        onPlay: function () {
                            goToNextVideo(obj[0].id);
                        },
                        onCancel: function () {
                            // l'utente ha annullato: niente altri autoplay
                            // per questo video
                            goToNextVideoSem = false;
                        }
                    });
                });
            }
        }
    });
}
